import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import b from "../Icon/Icon.js";
import { clsx as t } from "../../../node_modules/clsx/dist/clsx.m.js";
import r from "./Breadcrumb.module.scss.js";
const l = ({
  iconName: m,
  text: n,
  isSelected: e = !1,
  isRtl: c = !1,
  onClick: a
}) => /* @__PURE__ */ s.jsxs(
  "div",
  {
    className: t(r.breadcrumb, {
      "cursor-not-allowed": e,
      "cursor-pointer": !e
    }),
    children: [
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          role: "button",
          tabIndex: 0,
          onClick: a,
          onKeyDown: (o) => {
            (o.key === "Enter" || o.key === " ") && (a == null || a());
          },
          className: t(r.breadcrumb__link, {
            [r["breadcrumb__link--with-icon"]]: !!m,
            [r["breadcrumb__link--selected"]]: e
          }),
          children: [
            !!m && /* @__PURE__ */ s.jsx(
              b,
              {
                name: m,
                size: "xxs",
                className: r.breadcrumb__icon
              }
            ),
            /* @__PURE__ */ s.jsx(
              "span",
              {
                className: t(r.breadcrumb__text, {
                  [r["breadcrumb__text--selected"]]: e
                }),
                children: n
              }
            )
          ]
        }
      ),
      !e && /* @__PURE__ */ s.jsx(
        b,
        {
          name: c ? "corner-down-left" : "corner-down-right",
          size: "xxs",
          className: r.breadcrumb__separator
        }
      )
    ]
  }
);
export {
  l as default
};
//# sourceMappingURL=Breadcrumb.js.map
